import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "@services/authentication/auth.context";
import { HOME_PATH } from "@routes/path";
import type UserRole from "src/types/UserRole.interface";

interface RoleProtectedRouteProps {
  requiredRoles: UserRole[];
}

export function RoleProtectedRoute({ requiredRoles }: RoleProtectedRouteProps) {
  const authContext = useContext(AuthContext);
  const user = authContext?.user;

  if (!user || !requiredRoles.includes(user.role)) {
    return <Navigate to={HOME_PATH} replace />;
  }

  return <Outlet />;
}

